import { defineComponent as y, computed as g, openBlock as d, createElementBlock as i, normalizeClass as B, createElementVNode as n, renderSlot as r, ref as _, onMounted as z, onUnmounted as T, createBlock as A, Transition as I, withCtx as S, unref as q, createVNode as D, createCommentVNode as N, normalizeStyle as W } from "vue";
const G = { class: "modal-app-wrap" }, H = /* @__PURE__ */ y({
  __name: "ModalApp",
  props: ["xs", "s", "m", "l", "xl", "size"],
  setup(e) {
    const o = e, c = g(() => {
      const l = [o.size ? "modal-prop--" + o.size.toLowerCase() : ""];
      return Object.keys(o).forEach((a) => {
        o[a] !== void 0 && l.push("modal-prop--" + a);
      }), l;
    });
    return (l, a) => (d(), i("div", {
      class: B(["modal-app", c.value])
    }, [
      n("div", G, [
        r(l.$slots, "default")
      ])
    ], 2));
  }
}), m = (e, o) => {
  const c = e.__vccOpts || e;
  for (const [l, a] of o)
    c[l] = a;
  return c;
}, V = {}, O = { class: "modal-layout" };
function j(e, o) {
  return d(), i("div", O, [
    r(e.$slots, "default")
  ]);
}
const K = /* @__PURE__ */ m(V, [["render", j]]), R = {}, U = { class: "modal-content" };
function F(e, o) {
  return d(), i("div", U, [
    r(e.$slots, "default")
  ]);
}
const J = /* @__PURE__ */ m(R, [["render", F]]), P = {}, Q = { class: "modal-actions" };
function X(e, o) {
  return d(), i("div", Q, [
    r(e.$slots, "default")
  ]);
}
const Y = /* @__PURE__ */ m(P, [["render", X]]), Z = {}, ee = { class: "modal-title" }, oe = {
  id: "gdModalModalTitle",
  tabindex: "-1"
};
function te(e, o) {
  return d(), i("div", ee, [
    n("span", oe, [
      r(e.$slots, "default")
    ])
  ]);
}
const ne = /* @__PURE__ */ m(Z, [["render", te]]), le = {}, se = { class: "modal-disclaimer base ts0" };
function ce(e, o) {
  return d(), i("div", se, [
    r(e.$slots, "default")
  ]);
}
const de = /* @__PURE__ */ m(le, [["render", ce]]), ae = {}, re = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 30 30",
  "xml:space": "preserve"
};
function ie(e, o) {
  return d(), i("svg", re, o[0] || (o[0] = [
    n("g", null, [
      n("circle", {
        cx: "15",
        cy: "15",
        r: "15.094",
        style: { fill: "rgb(255, 255, 255)" }
      }),
      n("circle", {
        class: "circle2",
        cx: "15",
        cy: "15",
        r: "10.166"
      })
    ], -1),
    n("g", {
      transform: "translate(8,8) scale(0.7)",
      style: { fill: "rgb(255, 255, 255)", "fill-rule": "evenodd", "clip-rule": "evenodd" }
    }, [
      n("g", null, [
        n("path", {
          class: "st1",
          d: `M12.706,10l4.736-4.736c0.744-0.744,0.744-1.962,0-2.706c-0.744-0.744-1.962-0.744-2.706,0L10,7.294
		L5.264,2.558c-0.744-0.744-1.962-0.744-2.706,0c-0.744,0.744-0.744,1.962,0,2.706L7.294,10l-4.736,4.736
		c-0.744,0.744-0.744,1.962,0,2.706c0.744,0.744,1.962,0.744,2.706,0L10,12.706l4.736,4.736c0.744,0.744,1.962,0.744,2.706,0
		c0.744-0.744,0.744-1.962,0-2.706L12.706,10z`
        })
      ])
    ], -1)
  ]));
}
const me = /* @__PURE__ */ m(ae, [["render", ie]]);
function C() {
  const e = {
    w: document.documentElement && document.documentElement.clientWidth || window.innerWidth,
    h: document.documentElement && document.documentElement.clientHeight || window.innerHeight
  }, o = document.createElement("div");
  return document.body.appendChild(o), document.body.removeChild(o), {
    w: e.w,
    h: e.h
  };
}
const ue = {
  class: "gd-modal-component-container",
  id: "gdModalComponentContainer",
  tabindex: "-1",
  "aria-modal": "true",
  "aria-labelledby": "gdModalModalTitle"
}, fe = ["data-qe-id", "aria-label"], _e = /* @__PURE__ */ y({
  __name: "GdModal",
  props: {
    qeIdCloseBtn: { default: "gd-modal--close-button" },
    blocked: { type: Boolean, default: !1 },
    onClose: {}
  },
  emits: ["closeESC", "close", "closeBG"],
  setup(e, { emit: o }) {
    const c = e, l = o, a = _(null), v = _(null), h = {
      en: "close",
      de: "schließen",
      fr: "fermer",
      es: "cerrar",
      nl: "Sluiten",
      da: "luk",
      sv: "stäng"
    };
    let $ = g(() => !!c.onClose), f = _(C().h), p;
    z(() => {
      document.addEventListener("keydown", (s) => {
        c.blocked || s.code === "Escape" && l("closeESC");
      }), window.addEventListener("resize", k);
      const t = document.getElementById("gdModalComponentContainer");
      t && t.focus();
    }), T(() => {
      window.removeEventListener("resize", k);
    });
    const w = g(() => f.value - (f.value < 300 ? 50 : 100) + "px");
    function x() {
      c.blocked || l("close");
    }
    function E(t, s) {
      (t.key === "Enter" || t.key === " ") && (t.preventDefault(), l("close"));
    }
    function b(t) {
      (!c.blocked && a.value === t.target || v.value === t.target) && l("closeBG");
    }
    function k() {
      clearTimeout(p), p = setTimeout(() => {
        f.value = C().h, clearTimeout(p);
      }, 500);
    }
    function M() {
      const t = document.documentElement.getAttribute("lang");
      return t || document.body.getAttribute("lang") || "en";
    }
    function L() {
      return h[M()] || h.en;
    }
    return (t, s) => (d(), A(I, { name: "gd-modal-component" }, {
      default: S(() => [
        n("div", {
          ref_key: "backgroundClick",
          ref: a,
          class: "gd-modal-component-mask",
          onClick: s[2] || (s[2] = (u) => b(u)),
          role: "dialog"
        }, [
          n("div", {
            ref_key: "backgroundClickWrapper",
            ref: v,
            class: "gd-modal-component-wrapper",
            onClick: s[1] || (s[1] = (u) => b(u))
          }, [
            n("div", ue, [
              !t.blocked && q($) ? (d(), i("div", {
                key: 0,
                "data-qe-id": t.qeIdCloseBtn,
                class: "gd-modal-component-close",
                onClick: x,
                onKeydown: s[0] || (s[0] = (u) => E(u)),
                "aria-keyshortcuts": "esc",
                role: "button",
                tabindex: "0",
                "aria-label": L()
              }, [
                D(me)
              ], 40, fe)) : N("", !0),
              r(t.$slots, "modal-top"),
              n("div", {
                class: "gd-modal-component-body",
                style: W(`max-height: ${w.value}`)
              }, [
                r(t.$slots, "default")
              ], 4)
            ])
          ], 512)
        ], 512)
      ]),
      _: 3
    }));
  }
});
function ge(e) {
  e.component("modal-app", H), e.component("modal-layout", K), e.component("modal-content", J), e.component("modal-actions", Y), e.component("modal-title", ne), e.component("modal-disclaimer", de);
}
export {
  _e as default,
  ge as loadModalComponents
};
